// noinspection DuplicatedCode

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinCostumer = createAsyncThunk(
  "Costumer/getMin",
  async ({ search }, thunkAPI) => {
    let formData = new FormData();
    formData.append("search", search);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getMinMasterCust",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getCostumer = createAsyncThunk(
  "Costumer/get",
  async ({ start, count, search }, thunkAPI) => {
    let formData = new FormData();
    formData.append("start", start);
    formData.append("count", count);
    formData.append("search", search);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getMasterCust",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const insertCostumer = createAsyncThunk(
  "Costumer/insert",
  async (
    {
      DetailAccountID,
      Jabatan,
      NamaCust,
      Kontak,
      Alamat,
      NPWP,
      AlamatNPWP,
      Catatan,
      NoTlpn,
    },
    thunkAPI
  ) => {
    let formData = new FormData();
    formData.append("DetailAccountID", DetailAccountID);
    formData.append("Jabatan", Jabatan);
    formData.append("NamaCust", NamaCust);
    formData.append("Kontak", Kontak);
    formData.append("Alamat", Alamat);
    formData.append("NPWP", NPWP);
    formData.append("AlamatNPWP", AlamatNPWP);
    formData.append("Catatan", Catatan);
    formData.append("NoTlpn", NoTlpn);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "insertMasterCust",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const updateCostumer = createAsyncThunk(
  "Costumer/update",
  async (
    {
      DetailAccountID,
      Jabatan,
      NamaCust,
      Kontak,
      Alamat,
      NPWP,
      AlamatNPWP,
      Catatan,
      NoTlpn,
      CostumerID,
      status,
    },
    thunkAPI
  ) => {
    let formData = new FormData();
    formData.append("DetailAccountID", DetailAccountID);
    formData.append("Jabatan", Jabatan);
    formData.append("NamaCust", NamaCust);
    formData.append("Kontak", Kontak);
    formData.append("Alamat", Alamat);
    formData.append("NPWP", NPWP);
    formData.append("AlamatNPWP", AlamatNPWP);
    formData.append("Catatan", Catatan);
    formData.append("NoTlpn", NoTlpn);
    formData.append("CostumerID", CostumerID);
    formData.append("status", status);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "updateMasterCust",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

const initialState = {
  message: "",
  minData: [],
  isMinFetching: false,
  isMinSuccess: false,
  isMinError: false,
  isGetFetching: false,
  isGetSuccess: false,
  isGetError: false,
  isInsertFetching: false,
  isInsertSuccess: false,
  isInsertError: false,
  isUpdateFetching: false,
  isUpdateSuccess: false,
  isUpdateError: false,
  errorMessage: "",
};

export const CostumerSlice = createSlice({
  name: "Costumer",
  initialState,
  reducers: {},
  extraReducers: {
    [getMinCostumer.fulfilled]: (state, { payload }) => {
      state.isMinFetching = false;
      state.isMinSuccess = true;
      state.minData = payload.data;
      return state;
    },
    [getMinCostumer.rejected]: (state, { payload }) => {
      state.isMinFetching = false;
      state.isMinError = true;
      state.errorMessage = payload.message;
    },
    [getMinCostumer.pending]: (state) => {
      state.isMinFetching = true;
    },

    [getCostumer.fulfilled]: (state, { payload }) => {
      state.isGetFetching = false;
      state.isGetSuccess = true;
      state.data = payload.data;
      state.count = payload.count;
      state.message = payload.message;
      return state;
    },
    [getCostumer.rejected]: (state, { payload }) => {
      state.isGetFetching = false;
      state.isGetError = true;
      state.errorMessage = payload.message;
    },
    [getCostumer.pending]: (state) => {
      state.isGetFetching = true;
    },

    // INSERT
    [insertCostumer.fulfilled]: (state, { payload }) => {
      state.isInsertFetching = false;
      state.isInsertSuccess = true;
      state.message = payload.message;
      window.location.reload(false);
      return state;
    },
    [insertCostumer.rejected]: (state, { payload }) => {
      state.isInsertFetching = false;
      state.isInsertError = true;
      state.errorMessage = payload.message;
    },
    [insertCostumer.pending]: (state) => {
      state.isInsertFetching = true;
    },

    // UPDATE
    [updateCostumer.fulfilled]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateSuccess = true;
      state.message = payload.message;
      window.location.reload(false);
      return state;
    },
    [updateCostumer.rejected]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateError = true;
      state.errorMessage = payload.message;
    },
    [updateCostumer.pending]: (state) => {
      state.isUpdateFetching = true;
    },
  },
});

export const CostumerSelector = (state) => state.Costumer;
